import { getAuthCode } from "./getAuthCode";

export const postToLinkedin = async (postId, voiceId, imageUrl) => {
  try {
    const url = process.env.REACT_APP_BACKEND_URL + "/postToLinkedin?id=" + postId;
    const response = await fetch(url, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ auth_code: await getAuthCode(), voiceId, imageUrl })
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.log(error);
  }
};
